import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { ToolService, ToolServiceCreationPayload } from '@frontend/types';

const TOOLS_MANAGEMENT_URL = `${OPAL_URL}/tools-mgmt-service`;

export function createToolRegistry(payload: ToolServiceCreationPayload) {
  const finalPayload = {
    ...payload,
    organization_id: payload.instance_id,
  };
  return http.post(`${TOOLS_MANAGEMENT_URL}/api/tools-service/register`, finalPayload);
}

export const getToolRegistries = ({ instanceId }: { instanceId: string }) => {
  const key = ['tool-registries', instanceId];
  return {
    key,
    queryFn: async () => {
      const response = await http.get<ToolService[]>(
        `${TOOLS_MANAGEMENT_URL}/api/tools-service?organization_id=${instanceId}`
      );
      return response.data;
    },
  };
};

export function syncToolRegistry(registry_id: string) {
  return http.post(`${TOOLS_MANAGEMENT_URL}/api/tools-service/${registry_id}/sync`);
}

export function deleteToolRegistry(registry_id: string) {
  return http.delete(`${TOOLS_MANAGEMENT_URL}/api/tools-service/${registry_id}`);
}
